import { defineStore } from "pinia";

export const useAssetStore = defineStore("asset", {
  state: () => ({
    asset: getStoredAsset()
  }),
  actions: {
    setAsset(asset) {
      this.asset = asset;
      sessionStorage.setItem("asset", JSON.stringify(asset));
    },
    clearAsset() {
      this.asset = null;
      sessionStorage.removeItem("asset");
    },
    reset(){
      this.clearAsset();
    }
  }
});

// Helper function to safely retrieve and parse stored asset
function getStoredAsset() {
  try {
    const storedAsset = sessionStorage.getItem("asset");

    if (!storedAsset) {
      sessionStorage.removeItem("asset"); // Ensure stale key is removed
      return null;
    }

    return JSON.parse(storedAsset);
  } catch (error) {
    console.error("Error parsing asset from sessionStorage, clearing it:", error);
    sessionStorage.removeItem("asset"); // Remove if parsing fails
    return null;
  }
}
